export class Storage {
    name: string;
    handle: string;
    isRemote: boolean;
    isInUse: boolean;
    

    constructor(value?: Partial<Storage>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}